import React from "react";

interface Props {
  entityId: string | null;
}

const ChannelsSettingsTab: React.FC<Props> = ({ entityId }) => {
  return <div></div>;
};

export default ChannelsSettingsTab;
